module.exports = __webpack_public_path__ + "img/image.117a6d3e.svg";